import { create } from 'zustand';

interface UserState {
  user: any | null;
  idToken: string | null;
  initialized: boolean;

  setUser: (user: any | null) => void;
  setIdToken: (token: string | null) => void;
  setInitialized: () => void;
  reset: () => void;
}

export const useUserStore = create<UserState>((set) => ({
  user: null,
  idToken: null,
  initialized: false,

  setUser: (user) => set({ user }),
  setIdToken: (idToken) => set({ idToken }),
  setInitialized: () => set({ initialized: true }),

  reset: () =>
    set({
      user: null,
      idToken: null,
      initialized: false,
    }),
}));
